export default function email(){
$("#contact-form").submit(function (e) {
    e.preventDefault();
    const form = $(this);
    var name = $("#cf-name").val();
    var email = $("#cf-email").val();
    var cel = $("#cf-cel").val();
    var subject = $("#cf-subject").val();
    var message = $("#cf-message").val();
    var dataString = 'name=' + name + '&cel=' + cel +'&email=' + email + '&subject=' + subject + '&message=' + message;

    function isValidEmail(emailAddress) {
        var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
        return pattern.test(emailAddress);
    };

    function isValidPhone(celNumber) {
        if (cel.length < 1) {
            return false;
        }
        let celPattern = new RegExp(/^(\d{4,5}\-\d{4})?(\d{11})?(\(\d{2}\)?\d{9})?(\(\d{2}\)?\d{4,5}\-\d{4})?(\(\d{2}\)\s\d{9})?(\(\d{2}\)\s\d{4,5}\-\d{4})?(\(\d{2}\)\s\d{1}\s\d{4}\s\d{4})?(\d{2}\s\d{1}\s\d{4}\s\d{4})?$/i);
        return celPattern.test(celNumber);
    }

    var url = $(this).attr('action');

    if (isValidPhone(cel) == false) {
        $('.text-danger').text("Número de telefone inválido");
        $('.text-danger').fadeIn(1000, () => {
            $('.text-danger').delay(3000).fadeOut(500);
        });
        $('.text-success').fadeOut(500);
    }

    if (message.length < 1) {
        $('.text-danger').text("Mensagem precisa ser maior que 1 letra.");
        $('.text-danger').fadeIn(1000, () => {
            $('.text-danger').delay(3000).fadeOut(500);
        });
        $('.text-success').fadeOut(500);
    }

    if (subject.length < 1) {
        $('.text-danger').text("Assunto precisa ser maior que 1 letra.");
        $('.text-danger').fadeIn(1000, () => {
            $('.text-danger').delay(3000).fadeOut(500);
        });
        $('.text-success').fadeOut(500);
    }

    if (name.length < 1) {
        $('.text-danger').text("Nome precisa ter mais que uma letra.");
        $('.text-danger').fadeIn(1000, () => {
            $('.text-danger').delay(3000).fadeOut(500);
        });
        $('.text-success').fadeOut(500);
    }

    if (isValidEmail(email) == false) {
        $('.text-danger').text("Formato de email incorreto.");
        $('.text-danger').fadeIn(1000, () => {
            $('.text-danger').delay(3000).fadeOut(500);
        });
        $('.text-success').fadeOut(500);
    }

    if (isValidEmail(email) && (message.length > 1) && (subject.length > 1) && (name.length > 1) && isValidPhone(cel)) {
        grecaptcha.ready(() => {
            grecaptcha.execute(document.getElementById("recaptcha").value, {
                action: 'submit'
            }).then(token => {
                $.ajax({
                    type: "POST",
                    url: url,
                    headers: {
                      'X-CSRF-Token': $('input[name="_token"]').val(),
                      },
                    data: dataString += `&gRecaptchaResponse=${token}`,
                    success: function (data) {
                        if (typeof data === "string") {
                            try {
                                data = JSON.parse(data);
                            } catch (e) {
                                console.error("Erro ao analisar a resposta do servidor:", e);
                                console.error("Resposta do servidor:", data);
                                data = { status: false, message: "Erro inesperado no servidor." };
                            }
                        }
                        if (data.status === true) {
                            $('.text-success').text("Mensagem enviada com sucesso!")
                            $('.text-success').fadeIn(1000, () => {
                                $('.text-success').delay(3000).fadeOut(500);
                            });
                            $('.text-danger').fadeOut(500);
                            form[0].reset();
                        } else {
                            $('.text-danger').text(data.message)
                            $('.text-danger').fadeIn(1000, () => {
                                $('.text-danger').delay(3000).fadeOut(500);
                            });
                            $('.text-success').fadeOut(500);
                        }
                    },
                    error: function (xmlHttpRequest, textStatus, errorThrown) {
                        alert(errorThrown);
                   }
                });
            });
        });
    }
    else {
        $('.text-danger').fadeIn(1000);
        $('.text-success').fadeOut(500);
    }
    return false;
  });
}
